const getIFrameElementById = (id: string): HTMLIFrameElement | null =>
  id != null ? (document.querySelector(`iframe#${id}`) as HTMLIFrameElement) : null;

export default getIFrameElementById;
